import {
  Component,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AggregateStatus } from '../../models';

@Component({
  selector: 'backoffice-aggregate-status',
  templateUrl: './aggregate-status.component.html',
  styleUrls: ['./aggregate-status.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AggregateStatusComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AggregateStatusComponent
  implements OnInit, OnDestroy, ControlValueAccessor
{
  @Input() label!: string;

  aggregateStatusList = [...Object.keys(AggregateStatus)];

  aggregateStatusControl!: FormControl;

  _aggregateStatus: AggregateStatus[] | null = null;
  get aggregateSubType() {
    return this._aggregateStatus;
  }
  set aggregateStatus(val: AggregateStatus[] | null) {
    this._aggregateStatus = val;
    this.propagateChange(this._aggregateStatus);
  }

  _destroy$ = new Subject<void>();

  ngOnInit() {
    this.aggregateStatusControl = new FormControl(null);

    this.aggregateStatusControl.valueChanges
      .pipe(takeUntil(this._destroy$))
      .subscribe((value) => {
        if (Array.isArray(value) && value.length > 0) {
          this.aggregateStatus = value;
        } else {
          this.aggregateStatus = null;
        }
      });
  }

  propagateChange = (_: unknown) => {
    /* empty on purpose */
  };

  registerOnChange(fn: (_: unknown) => void) {
    this.propagateChange = fn;
  }

  registerOnTouched() {
    /* empty on purpose */
  }

  writeValue(value: AggregateStatus[]) {
    this.aggregateStatus = value;
    if (this.aggregateStatusControl) {
      this.aggregateStatusControl.setValue(this.aggregateSubType);
    }
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
